import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useRestaurant } from "../context/RestaurantContext";
import Profile from "./Profile";

const BottomNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isRestaurantOpen } = useRestaurant();
  const [isUserModalOpen, setIsUserModalOpen] = React.useState(false);

  const isActive = (path: string) => location.pathname === path;

  // Hide bottom navbar on home page when restaurant is closed
  if (location.pathname === "/" && !isRestaurantOpen) {
    return null;
  }

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-900 shadow-[0_-2px_10px_rgba(0,0,0,0.1)] dark:shadow-[0_-2px_10px_rgba(255,255,255,0.1)] z-[9999] border-t border-gray-200 dark:border-gray-700 transition-colors" style={{ position: 'fixed' }}>
      <div className="flex justify-around items-center px-4 py-3">
        {/* Home */}
        <div
          onClick={() => navigate("/")}
          className="flex flex-row items-center justify-center gap-1 cursor-pointer"
        >
          <div
            className={`w-10 h-10 rounded-full flex items-center justify-center transition-all ${
              isActive("/") ? "bg-[#FF8A00]" : "bg-gray-100 dark:bg-gray-700"
            }`}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.02 2.84016L3.63 7.04016C2.73 7.74016 2 9.23016 2 10.3602V17.7702C2 20.0902 3.89 21.9902 6.21 21.9902H17.79C20.11 21.9902 22 20.0902 22 17.7802V10.5002C22 9.29016 21.19 7.74016 20.2 7.05016L14.02 2.72016C12.62 1.74016 10.37 1.79016 9.02 2.84016Z"
                stroke={isActive("/") ? "white" : "#6A6A6A"}
                className={!isActive("/") ? "dark:stroke-gray-300" : ""}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <span
            className={`text-xs font-medium ${
              isActive("/") ? "text-[#FF8A00]" : "text-gray-600 dark:text-gray-300"
            }`}
          >
            Home
          </span>
        </div>

        {/* Dish */}
        <div
          onClick={() => navigate("/dish")}
          className="flex flex-row items-center justify-center gap-1 cursor-pointer"
        >
          <div
            className={`w-10 h-10 rounded-full flex items-center justify-center transition-all ${
              isActive("/dish") ? "bg-[#FF8A00]" : "bg-gray-100 dark:bg-gray-700"
            }`}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.5 19C10.433 19 12 17.433 12 15.5C12 13.567 10.433 12 8.5 12C6.567 12 5 13.567 5 15.5C5 17.433 6.567 19 8.5 19Z"
                stroke={isActive("/dish") ? "white" : "#6A6A6A"}
                className={!isActive("/dish") ? "dark:stroke-gray-300" : ""}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M15.5 12C17.433 12 19 10.433 19 8.5C19 6.567 17.433 5 15.5 5C13.567 5 12 6.567 12 8.5C12 10.433 13.567 12 15.5 12Z"
                stroke={isActive("/dish") ? "white" : "#6A6A6A"}
                className={!isActive("/dish") ? "dark:stroke-gray-300" : ""}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <span
            className={`text-xs font-medium ${
              isActive("/dish") ? "text-[#FF8A00]" : "text-gray-600 dark:text-gray-300"
            }`}
          >
            Dish
          </span>
        </div>

        {/* Order */}
        <div
          onClick={() => navigate("/orders")}
          className="flex flex-row items-center justify-center gap-1 cursor-pointer"
        >
          <div
            className={`w-10 h-10 rounded-full flex items-center justify-center transition-all ${
              isActive("/orders") ? "bg-[#FF8A00]" : "bg-gray-100 dark:bg-gray-700"
            }`}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2 2H3.74001C4.82001 2 5.67 2.93 5.58 4L4.75 13.96C4.61 15.59 5.89999 16.99 7.53999 16.99H18.19C19.63 16.99 20.89 15.81 21 14.38L21.54 6.88C21.66 5.22 20.4 3.87 18.73 3.87H5.82001"
                stroke={isActive("/orders") ? "white" : "#6A6A6A"}
                className={!isActive("/orders") ? "dark:stroke-gray-300" : ""}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <span
            className={`text-xs font-medium ${
              isActive("/orders") ? "text-[#FF8A00]" : "text-gray-600 dark:text-gray-300"
            }`}
          >
            Order
          </span>
        </div>

        {/* Profile */}
        <div
          onClick={() => setIsUserModalOpen(true)}
          className="flex flex-row items-center justify-center gap-1 cursor-pointer"
        >
          <div
            className={`w-10 h-10 rounded-full flex items-center justify-center transition-all ${
              isActive("/profile") ? "bg-[#FF8A00]" : "bg-gray-100 dark:bg-gray-700"
            }`}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z"
                stroke={isActive("/profile") ? "white" : "#6A6A6A"}
                className={!isActive("/profile") ? "dark:stroke-gray-300" : ""}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M20.5899 22C20.5899 18.13 16.7399 15 11.9999 15C7.25991 15 3.40991 18.13 3.40991 22"
                stroke={isActive("/profile") ? "white" : "#6A6A6A"}
                className={!isActive("/profile") ? "dark:stroke-gray-300" : ""}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <span
            className={`text-xs font-medium ${
              isActive("/profile") ? "text-[#FF8A00]" : "text-gray-600 dark:text-gray-300"
            }`}
          >
            Profile
          </span>
        </div>
      </div>

      {/* Profile Modal */}
      {isUserModalOpen && <Profile setIsUserModalOpen={setIsUserModalOpen} />}
    </nav>
  );
};

export default BottomNavbar;
